import apiClient from './apiClient';

const adminService = {
    getStats: () => apiClient.get(`/admin/stats`),
    getUsers: (params) => apiClient.get(`/admin/users`, { params }),
    updateUser: (userId, data) => apiClient.put(`/admin/users/${userId}`, data),
    deleteUser: (userId) => apiClient.delete(`/admin/users/${userId}`),
    getLogs: () => apiClient.get(`/admin/logs`),
    // Diagnostics
    getHealth: () => apiClient.get(`/admin/diagnostics/health`),
    checkDb: () => apiClient.get(`/admin/diagnostics/db`),
    checkSmtp: () => apiClient.post(`/admin/diagnostics/smtp`),
    getConfig: () => apiClient.get(`/admin/diagnostics/config`),
    pruneCache: () => apiClient.post(`/admin/diagnostics/prune`),

    getAuditLogs: (params) => apiClient.get(`/admin/audit-logs`, { params }),
    getSystemErrors: (params) => apiClient.get(`/admin/errors`, { params }),
    getBilling: (userId) => apiClient.get(`/admin/users/${userId}/billing`),
    syncBilling: (userId) => apiClient.post(`/admin/users/${userId}/billing/sync`),
    getSystemFlags: () => apiClient.get(`/admin/system-flags`),
    updateSystemFlags: (data) => apiClient.put(`/admin/system-flags`, data),
    getAdminSettings: () => apiClient.get(`/admin/settings`, { silent: true }),
    updateAdminSettings: (data) => apiClient.put(`/admin/settings`, data, { silent: true }),
    getDailyMetrics: () => apiClient.get(`/admin/daily-metrics`),
    getLlmBackend: () => apiClient.get(`/admin/llm-backend`, { silent: true }),
    adjustUserCredits: (userId, data) => apiClient.post(`/admin/users/${userId}/credits`, data),
    adjustGlobalCredits: (data) => apiClient.post(`/admin/users/global/credits`, data),
    // AI Script & Pipeline Phases Quality Diagnostic (docs/plan.md Batch 3/4).
    // Multipart — either a generation_id or uploaded script/research files,
    // plus (in upload mode) the admin's declared expected parameters. LLM
    // calls on the backend can take a while, so a generous client timeout.
    runQualityDiagnostic: (formData) => apiClient.post(`/admin/quality-checker/audit`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000,
    }),
};

export default adminService;
